module.exports = __webpack_public_path__ + "img/harvest_2.75266d01.png";